import { get, onChildAdded, onChildChanged, onValue, ref } from "firebase/database";
import { db, rtDb } from "./firebase.utils";
import { doc, getDoc, query as fbQuery, endAt, orderBy, getDocs, collection, onSnapshot } from "firebase/firestore";

export async function getCompletedEvalDataFromRtDb(e) {
    // fetch completed evaluation data from Realtime Database
    // e should contain evalId and cstKey
    // e also contains a callback function to handle the result
    if (!e || !e.evalId || !e.cstKey) {
        console.log('Invalid parameters for getCompletedEvalDataFromRtDb');
        e.callback(null);
        return;
    }
    const completedEvalRef = ref(rtDb, `completedEvals/${e.cstKey}/${e.evalId}`);
    const snapshot = await get(completedEvalRef).then(snap => {
        return snap.exists() ? snap.val() : null;
    }).catch(err => {
        console.log('Error fetching data from RTDB:', err);
        e.callback(null);
        return;
    })

    let completedEvalData = {};
    if (!snapshot) {
        console.log('No data available');
        e.callback(null);
        return;
    }
    completedEvalData.comp = snapshot;

    const evalDataRef = doc(db, 'evals', e.evalId);
    const evalDoc = await getDoc(evalDataRef);
    if (evalDoc.exists()) {
        completedEvalData.eval = evalDoc.data();
    } else {
        console.log('No eval data available');
        e.callback(null);
        return;
    }

    const userDataRef = doc(db, 'users', e.cstKey);
    const userDoc = await getDoc(userDataRef);
    if (userDoc.exists()) {
        completedEvalData.user = userDoc.data();
    } else {
        console.log('No user data available');
        e.callback(null);
        return;
    }

    e.callback(completedEvalData);
}

export async function getCompletedEvalDataFromFirestore(e) {
    if (!e || !e.evalId || !e.cstKey) {
        console.log('Invalid parameters for getCompletedEvalDataFromRtDb');
        e.callback(null);
        return;
    }
    const completedEvalData = {};
    const docRef = doc(db, `users/${e.cstKey}/completedEvals/${e.evalId}`);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        completedEvalData.comp = docSnap.data();
    } else {
        console.log('No eval data available');
        e.callback({'error': 'no user completed eval data'});
    }

    const evalDataRef = doc(db, 'evals', e.evalId);
    const evalDoc = await getDoc(evalDataRef);
    if (evalDoc.exists()) {
        completedEvalData.eval = evalDoc.data();
    } else {
        console.log('No eval data available');
        e.callback({'error': 'no eval data'});
        return;
    }

    const userDataRef = doc(db, 'users', e.cstKey);
    const userDoc = await getDoc(userDataRef);
    if (userDoc.exists()) {
        completedEvalData.user = userDoc.data();
    } else {
        console.log('No user data available');
        e.callback({'error': 'no user data'});
        return;
    }

    e.callback(completedEvalData);
}

export async function getEvalListFromRtDb(e) {
    let evalListRef;

    evalListRef = ref(rtDb, 'evalList');

    if (e.once) {
        const snapshot = await get(evalListRef);
        if (snapshot.exists()) {
            e.callback(snapshot.val());
        } else {
            console.log("No data available");
            e.callback(null);
        }
        return;
    }
    onChildAdded(evalListRef, (snapshot) => {
        if (snapshot.exists()) {
            e.callback(snapshot.val());
        } else {
            console.log("No data available");
            e.callback(null);
        }
    });
    onChildChanged(evalListRef, (snapshot) => {
        if (snapshot.exists()) {
            e.callback(snapshot.val());
        } else {
            console.log("No data available");
            e.callback(null);
        }
    });
    if (e.handleListener) {
        e.handleListener(evalListRef);
    }
}

export async function getEvalDataFromDb(e)  {
    let evalRef;

    if (e.evalId) {
        evalRef = doc(db, 'userEvaluations', e.evalId);
    }
    if (e.recent) {
        // get evaluations from the last 10 days
        // this is to limit the number of evaluations fetched

        // get timestamps in milliseconds from beginning of day 10 days ago
        const tenDaysAgo = new Date();
        tenDaysAgo.setHours(0, 0, 0, 0);
        tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
        const tsTenDaysAgo = tenDaysAgo.getTime();
        evalRef = fbQuery(collection(db, 'userEvaluations'), orderBy('ts', 'desc'), endAt(tsTenDaysAgo));
    }

    if (e.once) {
        const responseObj = {};
        const evalSnap = await getDocs(evalRef);
        if (!evalSnap.empty) {
            evalSnap.docs.map(doc => {
                responseObj[doc.id] = doc.data();
            });
        }
        e.callback(responseObj);
        return;
    }

    const unsubscribe = onSnapshot(evalRef, docs => {
        docs.forEach(doc => {
            let evalData = doc.data();
            e.callback(evalData);
        });
    })
    if (e.handleListener) {
        e.handleListener(unsubscribe);
    }
}